// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable()
export class CommandCenterService {
  public redirectFrom: any;

  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }

  //Get Command Center Cpp Data
  public getCommandCenterCppData(filter) {
    return this.networkService.postRequest(this.configService.getCommandCenterCppData(), filter);
  }

  // Get Command Center Cpp Data
  public getCommandCenterSeedData(filter) {
    return this.networkService.postRequest(this.configService.getCommandCenterSeedData(), filter);
  }

  // Get Messgae Center Cpp Data
  public getMessageCenterData() {
    return this.networkService.getRequest(this.configService.getMessageCenterData());
  }

  public pinMessage(data) {
    return this.networkService.postRequest(this.configService.pinUnPinMessage(), data);
  }

  public readMessage(data) {
    return this.networkService.postRequest(this.configService.readMessage(), data);
  }

  // Get Knowledge Center Data
  public getKnowledgeCenterData(searchKeyword: string) {
    return this.networkService.getRequest(this.configService.getKnowledgeCenterData() + '?keyword=' + searchKeyword);
  }
  


}
